<alert></alert>
<app-config class="hidden" />
<p-confirmDialog></p-confirmDialog>

<!-- Same icon font the existing Edit menu relies on (its items use Font Awesome classes). -->
<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.3/css/all.min.css" />

<p-tieredmenu #headerMenu [model]="menuItems" [popup]="true" appendTo="body" [autoDisplay]="false" />

<app-note-shell
  [tabs]="noteTabs"
  [(activeTab)]="activeNoteTab"
  [eagerTabs]="eagerTabs">

  <!-- ===================== HEADER (same layout as the View page: switching modes keeps everything in place) ===================== -->
  <div noteHeader class="print:hidden">
    <app-note-header [title]="headerTitle" backLabel="Save and go back to notes" (back)="pageMenu('Home')">
      <button
        type="button"
        class="inline-flex h-11 w-11 cursor-pointer items-center justify-center rounded-full border-0 bg-transparent text-(--p-text-color) hover:bg-(--p-content-hover-background) focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
        [attr.aria-pressed]="isFavorite"
        [attr.aria-label]="isFavorite ? 'Remove from favorites' : 'Add to favorites'"
        [title]="isFavorite ? 'Remove from favorites' : 'Add to favorites'"
        (click)="toggleFavorite()">
        <!-- Favorite: filled red heart; otherwise a hollow black one. -->
        <span
          class="material-symbols-outlined"
          [ngClass]="isFavorite ? 'is-filled text-red-600 dark:text-red-500' : 'text-black dark:text-(--p-text-color)'"
          data-testid="favorite-icon"
          aria-hidden="true">favorite</span>
      </button>

      <button
        type="button"
        class="hidden h-11 w-11 cursor-pointer items-center justify-center rounded-full border-0 bg-transparent text-(--p-text-color) hover:bg-(--p-content-hover-background) focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary disabled:cursor-not-allowed disabled:opacity-40 lg:inline-flex"
        aria-label="Ask Notes"
        [title]="!isOnline ? 'AI features are only available in online mode' : 'Ask Notes'"
        [disabled]="!isOnline"
        (click)="openAskNotes()">
        <i class="pi pi-sparkles" aria-hidden="true"></i>
      </button>

      <!-- Mirrors the View page's "Edit" button, in the same slot. Saves first, then switches instantly. -->
      <p-button
        class="sm:hidden"
        icon="pi pi-eye"
        size="small"
        [outlined]="true"
        ariaLabel="View note"
        title="View note"
        styleClass="!h-11 !w-11"
        (onClick)="pageMenu('View')">
      </p-button>
      <p-button
        class="hidden sm:inline-flex"
        label="View"
        icon="pi pi-eye"
        size="small"
        [outlined]="true"
        styleClass="!h-11 !px-3"
        (onClick)="pageMenu('View')">
      </p-button>

      <button
        type="button"
        class="inline-flex h-11 w-11 cursor-pointer items-center justify-center rounded-full border-0 bg-transparent text-(--p-text-color) hover:bg-(--p-content-hover-background) focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
        aria-label="More actions"
        title="More actions"
        aria-haspopup="menu"
        (click)="headerMenu.toggle($event)">
        <span class="material-symbols-outlined" aria-hidden="true">more_vert</span>
      </button>
    </app-note-header>
  </div>

  <!-- ===================== NOTE: title, quick properties, tags, editor ===================== -->
  <ng-template notePanel="note">
    @if (isReady) {
      <!-- min-height fills the scroller's own visible height (note header + tab strip + this
           form's save/sync footer, ~8.6rem, plus safe-area insets, measured empirically) so the
           editor below still fills the screen even when the note has little content — see the
           editorSurfaceClasses wrapper + [fillHeight] a few lines down. -->
      <form
        [formGroup]="editNoteForm"
        class="flex min-h-[calc(100dvh-8.6rem-env(safe-area-inset-top)-env(safe-area-inset-bottom))] w-full flex-col px-2 py-2 sm:px-3 sm:py-3 lg:px-4"
        (submit)="$event.preventDefault()">

        <!-- Title -->
        <div class="relative mb-2">
          <input
            #TitleField
            type="text"
            formControlName="Title"
            placeholder="Title (optional)"
            aria-label="Title"
            autocomplete="off"
            class="h-11 w-full rounded-md border border-(--p-content-border-color) bg-(--p-content-background) px-3 pr-11 text-lg font-semibold text-(--p-text-color) placeholder:font-normal focus-visible:outline-2 focus-visible:outline-primary"
            [ngClass]="{ '!border-2 !border-red-500': f['Title'].invalid && f['Title'].touched }"
            (ngModelChange)="onOtherContentChanged($event)" />
          <button
            type="button"
            class="absolute right-1 top-1/2 inline-flex h-9 w-9 -translate-y-1/2 cursor-pointer items-center justify-center rounded-full border-0 bg-transparent text-(--p-text-muted-color) hover:bg-(--p-content-hover-background) focus-visible:outline-2 focus-visible:outline-primary"
            aria-label="Clear title"
            title="Clear title"
            (click)="clearTitle()">
            <span class="material-symbols-outlined !text-xl" aria-hidden="true">close</span>
          </button>
        </div>

        <!-- One wrapping row: status, type, tags (colour-coded, add/remove inline), reading tools.
             Mobile (< sm): nothing wraps — the dropdowns (+ expand button) form one line and the tags
             another, each scrolling horizontally when it overflows. -->
        <div class="mb-2 flex flex-wrap items-center gap-x-3 gap-y-2">
          <div class="order-1 flex min-w-0 flex-1 items-center gap-2 py-0.5 overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden sm:overflow-visible sm:flex-none sm:py-0 max-sm:[&>*]:shrink-0">
            <select
              formControlName="spaceId"
              name="spaceId"
              aria-label="Space"
              [attr.title]="isSpaceEditable ? null : 'A saved note\'s Space can\'t be changed here'"
              class="h-9 rounded-md border border-(--p-content-border-color) bg-(--p-content-background) px-2 text-sm text-(--p-text-color) focus-visible:outline-2 focus-visible:outline-primary disabled:cursor-not-allowed disabled:opacity-60"
              (change)="onOtherContentChanged($event); onSpaceSelectionChanged()">
              <option *ngFor="let space of spaceSelectItems" [ngValue]="space.id">{{ space.label }}</option>
            </select>
            <select
              formControlName="Status"
              name="Status"
              aria-label="Status"
              [attr.title]="statusSelectTitle"
              class="h-9 rounded-md border border-(--p-content-border-color) bg-(--p-content-background) px-2 text-sm text-(--p-text-color) focus-visible:outline-2 focus-visible:outline-primary"
              (change)="onStatusChanged($event)">
              <!-- Current statuses only; a note's old status is shown (not selectable) until a new one is picked. -->
              @for (option of statusOptions; track option.value) {
                <option [ngValue]="option.value" [disabled]="option.legacy" [attr.title]="option.title">{{ option.label }}</option>
              }
            </select>
            <select
              formControlName="NoteType"
              name="NoteType"
              aria-label="Type"
              class="h-9 rounded-md border border-(--p-content-border-color) bg-(--p-content-background) px-2 text-sm text-(--p-text-color) focus-visible:outline-2 focus-visible:outline-primary"
              (change)="onOtherContentChanged($event)">
              <option *ngFor="let type of types" [ngValue]="type">{{ type }}</option>
            </select>
          </div>

          <!-- Tags: neutral chips with a tag-colour dot (as in View); × removes, clicking the name edits; type to search or create.
               Space tags first (they're part of the shared note), then the user's own private tags (🔒). -->
          <div class="order-3 flex w-full min-w-0 flex-nowrap items-center gap-1.5 py-0.5 overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden sm:overflow-visible sm:order-2 sm:w-auto sm:flex-wrap sm:py-0 max-sm:[&>*]:shrink-0" role="list" aria-label="Tags">
            @for (tag of noteTags; track tag._id ?? tag.name; let i = $index) {
              <span
                role="listitem"
                class="note-tag-chip inline-flex h-7 items-center overflow-hidden rounded-full border border-gray-300 bg-white text-xs font-medium text-(--p-text-color) dark:border-slate-600 dark:bg-slate-800"
                [style.opacity]="tag.isActive === false ? 0.6 : null">
                @if (canManageTag(tag)) {
                  <button
                    type="button"
                    class="inline-flex h-full cursor-pointer items-center gap-1.5 border-0 bg-transparent pl-2.5 pr-1 text-inherit hover:bg-(--p-content-hover-background) focus-visible:outline-2 focus-visible:outline-offset-[-2px] focus-visible:outline-primary"
                    [title]="'Edit tag ' + tag.name"
                    (click)="openEditTagDialog(tag, i)">
                    <span class="h-2 w-2 flex-shrink-0 rounded-full border border-black/10" [style.backgroundColor]="tag.color || '#94a3b8'" aria-hidden="true"></span>
                    {{ tag.name }}</button>
                } @else {
                  <span class="inline-flex items-center gap-1.5 pl-2.5 pr-1">
                    <span class="h-2 w-2 flex-shrink-0 rounded-full border border-black/10" [style.backgroundColor]="tag.color || '#94a3b8'" aria-hidden="true"></span>
                    {{ tag.name }}</span>
                }
                <button
                  type="button"
                  class="inline-flex h-full w-6 cursor-pointer items-center justify-center border-0 bg-transparent text-inherit opacity-80 hover:opacity-100 focus-visible:outline-2 focus-visible:outline-offset-[-2px] focus-visible:outline-primary"
                  [attr.aria-label]="'Remove tag ' + tag.name"
                  [title]="'Remove tag ' + tag.name"
                  (click)="detachTagAt(i)">
                  <span class="material-symbols-outlined !text-base" aria-hidden="true">close</span>
                </button>
              </span>
            }
            @for (tag of privateNoteTags; track tag._id) {
              <span
                role="listitem"
                class="note-tag-chip inline-flex h-7 items-center overflow-hidden rounded-full border border-gray-300 bg-white text-xs font-medium text-(--p-text-color) dark:border-slate-600 dark:bg-slate-800"
                [style.opacity]="tag.isActive === false ? 0.6 : null">
                <button
                  type="button"
                  class="inline-flex h-full cursor-pointer items-center gap-1 border-0 bg-transparent pl-2 pr-1 text-inherit hover:bg-(--p-content-hover-background) focus-visible:outline-2 focus-visible:outline-offset-[-2px] focus-visible:outline-primary"
                  [title]="'Private tag (only you can see it) — edit ' + tag.name"
                  (click)="openEditTagDialog(tag, -1)">
                  <span class="h-2 w-2 flex-shrink-0 rounded-full border border-black/10" [style.backgroundColor]="tag.color || '#94a3b8'" aria-hidden="true"></span>
                  <i class="pi pi-lock !text-[0.625rem] opacity-70" aria-hidden="true"></i>
                  <span class="sr-only">Private tag:</span>{{ tag.name }}
                </button>
                <button
                  type="button"
                  class="inline-flex h-full w-6 cursor-pointer items-center justify-center border-0 bg-transparent text-inherit opacity-80 hover:opacity-100 focus-visible:outline-2 focus-visible:outline-offset-[-2px] focus-visible:outline-primary"
                  [attr.aria-label]="'Remove private tag ' + tag.name"
                  [title]="'Remove private tag ' + tag.name"
                  (click)="detachPrivateTag(tag)">
                  <span class="material-symbols-outlined !text-base" aria-hidden="true">close</span>
                </button>
              </span>
            }

            <p-autocomplete
              #quickTagAutocomplete
              class="w-40"
              inputStyleClass="!h-8 !w-full !rounded-full !px-3 !text-sm"
              [(ngModel)]="quickTagName"
              [ngModelOptions]="{ standalone: true }"
              [suggestions]="tagSuggestionGroups"
              [group]="true"
              optionGroupLabel="label"
              optionGroupChildren="items"
              [dropdown]="true"
              panelStyleClass="min-w-64"
              scrollHeight="22rem"
              [appendTo]="'body'"
              optionLabel="name"
              placeholder="Assign tag…"
              ariaLabel="Assign tag"
              dropdownAriaLabel="Show all tags"
              (onFocus)="showAvailableTagSuggestions()"
              (completeMethod)="searchTagSuggestions($event)"
              (onSelect)="onTagAutocompleteSelected($event)"
              (keydown.enter)="$event.preventDefault(); addQuickTag()">
              <ng-template let-group pTemplate="group">
                <div class="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wide text-(--p-text-muted-color)">
                  @if (group.scope === TAG_SCOPE.PRIVATE) {
                    <i class="pi pi-lock !text-[0.625rem]" aria-hidden="true"></i>
                  }
                  {{ group.label }}
                  @if (group.scope === TAG_SCOPE.PRIVATE && !canChangePrivateTags) {
                    <span class="font-normal normal-case tracking-normal">· {{ privateTagsBlockedReason }}</span>
                  }
                </div>
              </ng-template>
              <ng-template let-tag pTemplate="item">
                <div class="flex items-center gap-2">
                  <span class="h-3 w-3 shrink-0 rounded-full border border-black/10" [style.backgroundColor]="tag.color || '#94a3b8'"></span>
                  <div class="min-w-0 flex-1">
                    <div class="flex items-center gap-1 truncate text-sm font-medium">
                      @if (tag.scope !== TAG_SCOPE.SPACE) {
                        <i class="pi pi-lock !text-[0.625rem] opacity-70" aria-label="Private tag"></i>
                      }
                      {{ tag.name }}
                    </div>
                    <div class="truncate text-xs text-(--p-text-muted-color)">
                      {{ tag.scope === TAG_SCOPE.SPACE ? 'Space' : 'Private · only you' }} · {{ tag.tagType }}
                    </div>
                  </div>
                </div>
              </ng-template>
            </p-autocomplete>

            @if (quickTagInputText.trim()) {
              <!-- New-tag scope: an explicit choice wherever a Space tag can be created (SHARED Space, write
                   access); Space is the default. Otherwise new tags are simply private. -->
              @if (canCreateSpaceTags) {
                <p-selectbutton
                  [options]="tagScopeOptions"
                  [(ngModel)]="newTagScope"
                  [ngModelOptions]="{ standalone: true }"
                  [allowEmpty]="false"
                  optionLabel="label"
                  optionValue="value"
                  size="small"
                  ariaLabelledBy="newTagScopeLabel">
                  <ng-template #item let-option>
                    <span class="inline-flex items-center gap-1 text-xs" [title]="option.value === TAG_SCOPE.PRIVATE ? 'Only you can see private tags' : 'Visible to everyone in this Space'">
                      <i [class]="option.icon + ' !text-[0.7rem]'" aria-hidden="true"></i>{{ option.label }}
                    </span>
                  </ng-template>
                </p-selectbutton>
                <span id="newTagScopeLabel" class="sr-only">Create new tag as</span>
              }
              <button
                type="button"
                class="inline-flex h-8 cursor-pointer items-center gap-1 rounded-full border-0 bg-primary px-3 text-xs font-medium text-primary-contrast disabled:cursor-not-allowed disabled:opacity-50"
                [disabled]="isTagMutating"
                [title]="effectiveNewTagScope === TAG_SCOPE.PRIVATE ? 'Private tag — only you can see it' : 'Space tag — visible to everyone in this Space'"
                (click)="addQuickTag()">
                <span class="material-symbols-outlined !text-base" aria-hidden="true">add</span>
                @if (effectiveNewTagScope === TAG_SCOPE.PRIVATE) {
                  <i class="pi pi-lock !text-[0.625rem]" aria-hidden="true"></i>
                }
                {{ quickTagExistsInScope ? 'Add' : 'Create' }} “{{ quickTagInputText.trim() }}”
              </button>
            }

            <button
              type="button"
              class="inline-flex h-8 w-8 cursor-pointer items-center justify-center rounded-full border-0 bg-transparent text-(--p-text-muted-color) hover:bg-(--p-content-hover-background) focus-visible:outline-2 focus-visible:outline-primary"
              aria-label="Manage my private tags"
              title="Manage my private tags"
              (click)="openTagManager()">
              <i class="pi pi-tags" aria-hidden="true"></i>
            </button>
            <button
              type="button"
              class="inline-flex h-8 w-8 cursor-pointer items-center justify-center rounded-full border-0 bg-transparent text-(--p-text-muted-color) hover:bg-(--p-content-hover-background) focus-visible:outline-2 focus-visible:outline-primary disabled:cursor-not-allowed disabled:opacity-40"
              aria-label="Suggest tags with AI"
              [title]="!isOnline ? 'AI features are only available in online mode' : 'Suggest tags with AI'"
              [disabled]="aiSuggestTagsLoading || !isOnline"
              (click)="generateSuggestedTags()">
              <i class="pi" [ngClass]="aiSuggestTagsLoading ? 'pi-spin pi-spinner' : 'pi-sparkles'" aria-hidden="true"></i>
            </button>
            @if (quickTagInputText.trim() && canCreateSpaceTags && effectiveNewTagScope === TAG_SCOPE.PRIVATE) {
              <span class="hidden w-full text-xs text-(--p-text-muted-color) sm:inline">Private tags are visible only to you.</span>
            }
          </div>
          @if (quickTagInputText.trim() && canCreateSpaceTags && effectiveNewTagScope === TAG_SCOPE.PRIVATE) {
            <!-- Mobile: outside the horizontally scrolling tags row, so it gets its own full-width line. -->
            <span class="order-4 w-full text-xs text-(--p-text-muted-color) sm:hidden">Private tags are visible only to you.</span>
          }

          <div class="order-2 ml-auto flex items-center gap-1 print:hidden sm:order-3">
            <button
              type="button"
              class="inline-flex h-9 cursor-pointer items-center gap-1 rounded-md border-0 bg-transparent px-2 text-sm text-(--p-text-muted-color) hover:bg-(--p-content-hover-background) focus-visible:outline-2 focus-visible:outline-primary"
              [attr.aria-label]="areAllCollapsibleExpanded ? 'Collapse all sections' : 'Expand all sections'"
              [title]="areAllCollapsibleExpanded ? 'Collapse all sections' : 'Expand all sections'"
              (click)="toggleAllCollapsibleSections()">
              <span class="material-symbols-outlined !text-xl" aria-hidden="true">{{ areAllCollapsibleExpanded ? 'unfold_less' : 'unfold_more' }}</span>
              <span class="hidden lg:inline">{{ areAllCollapsibleExpanded ? 'Collapse' : 'Expand' }}</span>
            </button>
          </div>
        </div>

        <!-- Editor -->
        <div class="flex min-h-0 flex-1 flex-col" [ngClass]="editorSurfaceClasses">
          <app-rich-editor
            #descriptionEditor
            class="min-h-0 flex-1"
            editorId="EditDescription"
            [noteId]="note._id || noteId || null"
            [spaceId]="note.spaceId"
            [readOnly]="false"
            [placeholderText]="''"
            [content]="editNoteForm.get('DescriptionHtml')?.value"
            [fillHeight]="true"
            (saveShortcutTriggered)="handleSaveShortcut()"
            (contentUpdated)="onEditorHtmlContentUpdated('Description', $event)"
            (attachmentImageInserted)="onAttachmentImageInserted($event)"
            (noteLinkInserted)="onNoteLinkInserted($event)">
          </app-rich-editor>
        </div>
      </form>
    } @else {
      <div class="w-full animate-pulse space-y-3 px-2 py-3 lg:px-4" role="status" aria-busy="true">
        <div class="h-11 w-full rounded-md bg-surface-200 dark:bg-surface-700"></div>
        <div class="h-8 w-1/2 rounded bg-surface-200 dark:bg-surface-700"></div>
        <div class="h-64 w-full rounded bg-surface-200 dark:bg-surface-700"></div>
        <span class="sr-only">Loading note…</span>
      </div>
    }
  </ng-template>

  <!-- ===================== PROPERTIES (editable) ===================== -->
  <ng-template notePanel="properties">
    @if (isReady) {
      <form [formGroup]="editNoteForm" class="grid w-full grid-cols-1 items-start gap-3 px-2 py-2 sm:px-3 sm:py-3 lg:px-4 xl:grid-cols-2" (submit)="$event.preventDefault()">

        <details open class="group rounded-lg border border-surface-200 bg-surface-0 dark:border-surface-700 dark:bg-surface-900">
          <summary class="flex min-h-11 cursor-pointer list-none items-center justify-between px-3 text-base font-semibold focus-visible:outline-2 focus-visible:outline-primary">
            General
            <span class="material-symbols-outlined transition-transform group-open:rotate-180" aria-hidden="true">expand_more</span>
          </summary>
          <div class="space-y-3 px-3 pb-3">
            <label class="flex min-h-9 cursor-pointer items-center gap-2 text-sm">
              <input type="checkbox" formControlName="Confidential" class="h-4 w-4" (change)="onOtherContentChanged($event)" />
              Confidential
            </label>

            <!-- Status metadata: actionRequired (missing → off) and priority (missing → Normal). -->
            <div class="grid grid-cols-1 gap-3 sm:grid-cols-2">
              <label class="flex min-h-9 cursor-pointer items-center gap-3 text-sm">
                <p-toggleswitch formControlName="actionRequired" inputId="actionRequired" (onChange)="onOtherContentChanged($event)" />
                <span class="inline-flex items-center gap-1.5">
                  <i class="pi pi-flag-fill text-xs" [ngClass]="editNoteForm.controls['actionRequired'].value ? 'text-orange-600 dark:text-orange-400' : 'text-(--p-text-muted-color)'" aria-hidden="true"></i>
                  Action required
                </span>
              </label>
              <div>
                <label for="priority" class="mb-1 block text-xs font-medium uppercase tracking-wide text-(--p-text-muted-color)">Priority</label>
                <div class="relative">
                  @if (priorityIndicator(editNoteForm.controls['priority'].value); as indicator) {
                    @if (indicator.icon) {
                      <i class="pointer-events-none absolute left-2 top-1/2 -translate-y-1/2 text-sm" [ngClass]="[indicator.icon, indicator.colorClass]" aria-hidden="true"></i>
                    }
                  }
                  <select
                    id="priority"
                    name="priority"
                    formControlName="priority"
                    class="h-9 w-full rounded-md border border-(--p-content-border-color) bg-(--p-content-background) px-2 text-sm text-(--p-text-color) focus-visible:outline-2 focus-visible:outline-primary"
                    [class.pl-7]="priorityIndicator(editNoteForm.controls['priority'].value).icon"
                    (change)="onOtherContentChanged($event)">
                    @for (priority of priorityOptions; track priority) {
                      <option [ngValue]="priority">{{ priority }}</option>
                    }
                  </select>
                </div>
                @if (editNoteForm.controls['priority'].invalid) {
                  <small class="mt-1 block text-red-600 dark:text-red-400">Choose Low, Normal, High or Critical.</small>
                }
              </div>
            </div>

            <div>
              <div class="mb-1 flex items-center justify-between gap-2">
                <label for="Keywords" class="text-xs font-medium uppercase tracking-wide text-(--p-text-muted-color)">Keywords</label>
                <p-button
                  label="Generate"
                  icon="pi pi-sparkles"
                  size="small"
                  [outlined]="true"
                  [text]="true"
                  [loading]="aiKeywordsLoading"
                  [disabled]="aiKeywordsLoading || !isOnline"
                  [title]="!isOnline ? 'AI features are only available in online mode' : 'Generate keywords with AI'"
                  (onClick)="generateKeywords()">
                </p-button>
              </div>
              <input
                id="Keywords"
                name="Keywords"
                formControlName="Keywords"
                class="h-9 w-full rounded-md border border-(--p-content-border-color) bg-(--p-content-background) px-2 text-sm text-(--p-text-color) focus-visible:outline-2 focus-visible:outline-primary"
                (change)="onOtherContentChanged($event)" />
            </div>

            <div>
              <label for="AiKeywords" class="mb-1 block text-xs font-medium uppercase tracking-wide text-(--p-text-muted-color)">AI keywords</label>
              <input
                id="AiKeywords"
                name="AiKeywords"
                formControlName="AiKeywords"
                [readonly]="aiKeywordsLoading"
                class="h-9 w-full rounded-md border border-(--p-content-border-color) bg-(--p-content-background) px-2 text-sm text-(--p-text-color) focus-visible:outline-2 focus-visible:outline-primary" />
            </div>
          </div>
        </details>

        <details open class="group rounded-lg border border-surface-200 bg-surface-0 dark:border-surface-700 dark:bg-surface-900">
          <summary class="flex min-h-11 cursor-pointer list-none items-center justify-between px-3 text-base font-semibold focus-visible:outline-2 focus-visible:outline-primary">
            Dates &amp; Timeline
            <span class="material-symbols-outlined transition-transform group-open:rotate-180" aria-hidden="true">expand_more</span>
          </summary>
          <div class="px-3 pb-3">
            <div class="grid grid-cols-1 gap-3 sm:grid-cols-2">
              <div class="sm:col-span-2">
                <label for="ReferenceDate" class="mb-1 block text-xs font-medium uppercase tracking-wide text-(--p-text-muted-color)">Reference date</label>
                <p-datepicker
                  inputId="ReferenceDate"
                  formControlName="ReferenceDate"
                  [showIcon]="true"
                  iconDisplay="input"
                  [appendTo]="'body'"
                  [showButtonBar]="true"
                  dateFormat="dd.mm.yy"
                  styleClass="w-full"
                  inputStyleClass="w-full"
                  class="block w-full"
                  (onSelect)="onOtherContentChanged($event)">
                </p-datepicker>
              </div>
              <div>
                <label for="StartDate" class="mb-1 block text-xs font-medium uppercase tracking-wide text-(--p-text-muted-color)">Start</label>
                <p-datepicker
                  inputId="StartDate"
                  formControlName="StartDate"
                  [showIcon]="true"
                  iconDisplay="input"
                  [showTime]="true"
                  hourFormat="24"
                  [appendTo]="'body'"
                  [showButtonBar]="true"
                  dateFormat="dd.mm.yy"
                  styleClass="w-full"
                  inputStyleClass="w-full"
                  class="block w-full"
                  (onSelect)="onOtherContentChanged($event)">
                </p-datepicker>
              </div>
              <div>
                <label for="EndDate" class="mb-1 block text-xs font-medium uppercase tracking-wide text-(--p-text-muted-color)">End</label>
                <p-datepicker
                  inputId="EndDate"
                  formControlName="EndDate"
                  [showIcon]="true"
                  iconDisplay="input"
                  [showTime]="true"
                  hourFormat="24"
                  [appendTo]="'body'"
                  [showButtonBar]="true"
                  dateFormat="dd.mm.yy"
                  styleClass="w-full"
                  inputStyleClass="w-full"
                  class="block w-full"
                  (onSelect)="onOtherContentChanged($event)">
                </p-datepicker>
              </div>
              <div>
                <label for="dueDate" class="mb-1 block text-xs font-medium uppercase tracking-wide text-(--p-text-muted-color)">Due</label>
                <p-datepicker
                  inputId="dueDate"
                  formControlName="dueDate"
                  [showIcon]="true"
                  iconDisplay="input"
                  [showTime]="true"
                  hourFormat="24"
                  [appendTo]="'body'"
                  [showButtonBar]="true"
                  [showClear]="true"
                  dateFormat="dd.mm.yy"
                  styleClass="w-full"
                  inputStyleClass="w-full"
                  class="block w-full"
                  (onSelect)="onOtherContentChanged($event)"
                  (onClear)="onOtherContentChanged($event)"
                  (onClearClick)="onOtherContentChanged($event)"
                  (onInput)="onOtherContentChanged($event)">
                </p-datepicker>
                @if (editNoteForm.controls['dueDate'].invalid) {
                  <small class="mt-1 block text-red-600 dark:text-red-400">Enter a valid date and time, or leave it empty.</small>
                }
              </div>
              <div>
                <label for="completedOn" class="mb-1 block text-xs font-medium uppercase tracking-wide text-(--p-text-muted-color)">Completed</label>
                <p-datepicker
                  inputId="completedOn"
                  formControlName="completedOn"
                  [showIcon]="true"
                  iconDisplay="input"
                  [showTime]="true"
                  hourFormat="24"
                  [appendTo]="'body'"
                  [showButtonBar]="true"
                  [showClear]="true"
                  dateFormat="dd.mm.yy"
                  styleClass="w-full"
                  inputStyleClass="w-full"
                  class="block w-full"
                  (onSelect)="onOtherContentChanged($event)"
                  (onClear)="onOtherContentChanged($event)"
                  (onClearClick)="onOtherContentChanged($event)"
                  (onInput)="onOtherContentChanged($event)">
                </p-datepicker>
                @if (editNoteForm.controls['completedOn'].invalid) {
                  <small class="mt-1 block text-red-600 dark:text-red-400">Enter a valid date and time, or leave it empty.</small>
                }
              </div>
            </div>
            <dl class="m-0 mt-4 grid grid-cols-1 gap-x-6 gap-y-3 border-t border-surface-200 pt-3 text-(--p-text-muted-color) dark:border-surface-700 sm:grid-cols-2">
              <div><dt class="text-xs font-medium uppercase tracking-wide">Created</dt><dd class="m-0 mt-0.5 text-sm">{{ note.created_on | date: 'dd.MMM.yyyy HH:mm' }}</dd></div>
              <div><dt class="text-xs font-medium uppercase tracking-wide">Modified</dt><dd class="m-0 mt-0.5 text-sm">{{ note.last_modified | date: 'dd.MMM.yyyy HH:mm' }}</dd></div>
            </dl>
          </div>
        </details>

        <details open class="group rounded-lg border border-surface-200 bg-surface-0 dark:border-surface-700 dark:bg-surface-900">
          <summary class="flex min-h-11 cursor-pointer list-none items-center justify-between px-3 text-base font-semibold focus-visible:outline-2 focus-visible:outline-primary">
            AI &amp; Insights
            <span class="material-symbols-outlined transition-transform group-open:rotate-180" aria-hidden="true">expand_more</span>
          </summary>
          <div class="space-y-4 px-3 pb-3 text-sm">
            <div>
              <p-button
                [label]="aiSummaryButtonLabel"
                icon="pi pi-sparkles"
                size="small"
                [loading]="aiSummaryLoading"
                [disabled]="aiSummaryLoading || !isOnline"
                [title]="!isOnline ? 'AI features are only available in online mode' : ''"
                (onClick)="generateAiSummary()">
              </p-button>
            </div>

            @if (aiSummary; as summary) {
              @if (summary.summary_error) {
                <p class="m-0 rounded-md border border-red-300 bg-red-50 p-2 text-red-700 dark:border-red-800 dark:bg-red-950 dark:text-red-200" role="alert">{{ summary.summary_error }}</p>
              }
              @if (summary.summary_stale) {
                <p class="m-0 text-amber-700 dark:text-amber-300"><i class="pi pi-exclamation-triangle mr-1" aria-hidden="true"></i>This summary may be out of date.</p>
              }
              @if (summary.summary_one_sentence) {
                <div><div class="text-xs font-medium uppercase tracking-wide text-(--p-text-muted-color)">Summary</div><p class="m-0 mt-0.5 whitespace-pre-line">{{ summary.summary_one_sentence }}</p></div>
              }
              @if (summary.summary_paragraph && summary.summary_paragraph !== summary.summary_one_sentence) {
                <div><div class="text-xs font-medium uppercase tracking-wide text-(--p-text-muted-color)">Details</div><p class="m-0 mt-0.5 whitespace-pre-line">{{ summary.summary_paragraph }}</p></div>
              }
              @if (summary.summary_bullets?.length) {
                <div>
                  <div class="text-xs font-medium uppercase tracking-wide text-(--p-text-muted-color)">Key points</div>
                  <ul class="m-0 mt-1 list-disc space-y-1 pl-5">
                    @for (bullet of summary.summary_bullets; track $index) { <li>{{ bullet }}</li> }
                  </ul>
                </div>
              }
              @if (summary.summary_keywords?.length) {
                <div>
                  <div class="text-xs font-medium uppercase tracking-wide text-(--p-text-muted-color)">Keywords</div>
                  <div class="mt-1 flex flex-wrap gap-2">
                    @for (kw of summary.summary_keywords; track $index) {
                      <span class="rounded-full bg-(--p-content-hover-background) px-3 py-1 text-xs">{{ kw }}</span>
                    }
                  </div>
                </div>
              }
            } @else {
              <p class="m-0 text-(--p-text-muted-color)">No AI summary is available for this note.</p>
            }
          </div>
        </details>

        <details open class="group rounded-lg border border-surface-200 bg-surface-0 dark:border-surface-700 dark:bg-surface-900">
          <summary class="flex min-h-11 cursor-pointer list-none items-center justify-between px-3 text-base font-semibold text-(--p-text-muted-color) focus-visible:outline-2 focus-visible:outline-primary">
            Technical details
            <span class="material-symbols-outlined transition-transform group-open:rotate-180" aria-hidden="true">expand_more</span>
          </summary>
          <dl class="m-0 grid grid-cols-1 gap-x-6 gap-y-3 px-3 pb-3 text-(--p-text-muted-color) sm:grid-cols-2">
            <div class="sm:col-span-2">
              <dt class="text-xs font-medium uppercase tracking-wide">Note ID</dt>
              <dd class="m-0 mt-0.5 flex items-center gap-1 text-sm">
                <code class="min-w-0 break-all">{{ note._id }}</code>
                <button type="button" class="inline-flex h-9 w-9 shrink-0 cursor-pointer items-center justify-center rounded-full border-0 bg-transparent hover:bg-(--p-content-hover-background)" aria-label="Copy note ID" title="Copy note ID" (click)="copyNoteId()">
                  <span class="material-symbols-outlined !text-lg" aria-hidden="true">content_copy</span>
                </button>
              </dd>
            </div>
            <div><dt class="text-xs font-medium uppercase tracking-wide">Note size</dt><dd class="m-0 mt-0.5 text-sm">{{ noteSizeLabel }}</dd></div>
            <div><dt class="text-xs font-medium uppercase tracking-wide">Space</dt><dd class="m-0 mt-0.5 break-all text-sm">{{ note.spaceId || 'Private' }}</dd></div>
            <div><dt class="text-xs font-medium uppercase tracking-wide">Sync status</dt><dd class="m-0 mt-0.5 text-sm">{{ note.syncStatus || '—' }}</dd></div>
            <div><dt class="text-xs font-medium uppercase tracking-wide">Last synced</dt><dd class="m-0 mt-0.5 text-sm">{{ note.syncTime ? (note.syncTime | date: 'dd.MMM.yyyy HH:mm') : '—' }}</dd></div>
            @if (aiSummary; as ai) {
              <div><dt class="text-xs font-medium uppercase tracking-wide">AI summary status</dt>
                <dd class="m-0 mt-0.5 flex items-center gap-1 text-sm">
                  <span class="material-symbols-outlined !text-base" [ngClass]="aiSummaryStatusIconClass(ai.summary_status)" aria-hidden="true">{{ aiSummaryStatusIcon(ai.summary_status) }}</span>
                  {{ aiSummaryStatusLabel(ai.summary_status) }}
                </dd></div>
              @if (ai.summary_model) { <div><dt class="text-xs font-medium uppercase tracking-wide">AI model</dt><dd class="m-0 mt-0.5 text-sm">{{ ai.summary_model }}</dd></div> }
              @if (ai.summary_note_revision) { <div><dt class="text-xs font-medium uppercase tracking-wide">AI revision</dt><dd class="m-0 mt-0.5 break-all text-sm">{{ ai.summary_note_revision }}</dd></div> }
              @if (ai.summary_requested_at) { <div><dt class="text-xs font-medium uppercase tracking-wide">AI requested</dt><dd class="m-0 mt-0.5 text-sm">{{ ai.summary_requested_at | date: 'dd.MMM.yyyy HH:mm' }}</dd></div> }
              @if (ai.summary_generated_at) { <div><dt class="text-xs font-medium uppercase tracking-wide">AI generated</dt><dd class="m-0 mt-0.5 text-sm">{{ ai.summary_generated_at | date: 'dd.MMM.yyyy HH:mm' }}</dd></div> }
              @if (ai.summary_token_input || ai.summary_token_output) {
                <div><dt class="text-xs font-medium uppercase tracking-wide">AI tokens</dt><dd class="m-0 mt-0.5 text-sm">{{ ai.summary_token_input ?? '—' }} in / {{ ai.summary_token_output ?? '—' }} out</dd></div>
              }
            }
          </dl>
        </details>
      </form>
    }
  </ng-template>

  <!-- ===================== ATTACHMENTS (editable; rendered eagerly so saves can always reach the uploader) ===================== -->
  <ng-template notePanel="attachments">
    @if (isReady) {
      <div class="w-full px-2 py-2 sm:px-3 sm:py-3 lg:px-4">
        <app-file-upload [noteForm]="editNoteForm" [noteId]="note._id" [spaceId]="note.spaceId" [noteAttachments]="note.Attachments" [readOnly]="false" (countChange)="resolvedAttachmentCount = $event" (staged)="onAttachmentsStaged($event)" [extraAttachments]="insertedImageAttachments" (attachmentRemoved)="onAttachmentRemoved($event)"></app-file-upload>
      </div>
    }
  </ng-template>

  <!-- ===================== RELATED (editable) ===================== -->
  <ng-template notePanel="related">
    @if (isReady) {
      <div class="w-full px-2 py-2 sm:px-3 sm:py-3 lg:px-4">
        <div class="mb-2 flex flex-wrap items-center justify-between gap-2">
          <h2 class="m-0 text-base font-semibold">Linked notes <span class="font-normal text-(--p-text-muted-color)">({{ relatedNotes.length }})</span></h2>
          <div class="flex flex-wrap gap-2">
            <p-button label="Add related note" icon="pi pi-link" size="small" styleClass="!h-11" (onClick)="openAddRelatedNoteDialog()"></p-button>
            <p-button
              label="Find similar"
              icon="pi pi-sparkles"
              size="small"
              [outlined]="true"
              styleClass="!h-11"
              [loading]="similarForLinkLoading"
              [disabled]="!note._id || !isOnline"
              [title]="!isOnline ? 'AI features are only available in online mode' : 'Find similar notes to link'"
              (onClick)="openFindSimilarForLink()">
            </p-button>
          </div>
        </div>

        @if (relatedNoteObjects.length) {
          <ul class="m-0 list-none divide-y divide-surface-200 rounded-lg border border-surface-200 bg-surface-0 p-0 dark:divide-surface-700 dark:border-surface-700 dark:bg-surface-900">
            @for (ref of relatedNoteObjects; track ref.id; let i = $index) {
              <li class="flex min-h-14 items-center gap-2 px-2 py-1" [ngStyle]="relatedNoteRowStyle(ref.status)">
                <div class="flex shrink-0 flex-col">
                  <button type="button" class="inline-flex h-6 w-8 cursor-pointer items-center justify-center rounded border-0 bg-transparent text-inherit hover:bg-(--p-content-hover-background) disabled:cursor-not-allowed disabled:opacity-30" aria-label="Move up" title="Move up" [disabled]="i === 0" (click)="moveRelatedNote(i, -1)">
                    <i class="pi pi-chevron-up text-xs" aria-hidden="true"></i>
                  </button>
                  <button type="button" class="inline-flex h-6 w-8 cursor-pointer items-center justify-center rounded border-0 bg-transparent text-inherit hover:bg-(--p-content-hover-background) disabled:cursor-not-allowed disabled:opacity-30" aria-label="Move down" title="Move down" [disabled]="i === relatedNotes.length - 1" (click)="moveRelatedNote(i, 1)">
                    <i class="pi pi-chevron-down text-xs" aria-hidden="true"></i>
                  </button>
                </div>
                <div class="min-w-0 flex-1">
                  <a class="block truncate font-medium hover:underline focus-visible:outline-2 focus-visible:outline-primary" [routerLink]="['/view', ref.id]" target="_blank" rel="noopener" [ngStyle]="relatedNoteRowStyle(ref.status)">
                    {{ ref.title || '(Untitled)' }}
                  </a>
                  <div class="text-xs opacity-80">
                    {{ ref.status || '—' }}
                    @if (ref.lastModified) { · {{ ref.lastModified | date: 'dd MMM yyyy' }} }
                  </div>
                </div>
                @if (ref.aiSummary?.summary_status; as aiStatus) {
                  <span
                    class="material-symbols-outlined shrink-0 !text-xl"
                    [ngClass]="aiSummaryStatusIconClass(aiStatus)"
                    [attr.aria-label]="'AI summary: ' + aiSummaryStatusLabel(aiStatus)"
                    [pTooltip]="getAiSummaryTooltip(ref.aiSummary)"
                    tooltipPosition="left">{{ aiSummaryStatusIcon(aiStatus) }}</span>
                }
                <button
                  type="button"
                  class="inline-flex h-11 w-11 shrink-0 cursor-pointer items-center justify-center rounded-full border-0 bg-transparent text-red-600 hover:bg-(--p-content-hover-background) focus-visible:outline-2 focus-visible:outline-primary"
                  aria-label="Remove related note"
                  title="Remove"
                  (click)="logRelatedNoteTrashClick(i); requestRemoveRelatedNote(i)">
                  <i class="pi pi-trash" aria-hidden="true"></i>
                </button>
              </li>
            }
          </ul>
        } @else {
          <app-note-empty-state icon="link_off" title="No related notes linked yet" description="Use “Add related note” to link one." />
        }
      </div>
    }
  </ng-template>

  <!-- ===================== COMMENTS (editable rich text) ===================== -->
  <ng-template notePanel="comments">
    @if (isReady) {
      <div class="w-full px-2 py-2 sm:px-3 sm:py-3 lg:px-4" [ngClass]="editorSurfaceClasses">
        <app-rich-editor
          class="block w-full min-w-0"
          editorId="EditComments"
          [noteId]="note._id || noteId || null"
          [spaceId]="note.spaceId"
          [readOnly]="false"
          [placeholderText]="''"
          [content]="editNoteForm.get('CommentsHtml')?.value"
          (saveShortcutTriggered)="handleSaveShortcut()"
          (contentUpdated)="onEditorHtmlContentUpdated('Comments', $event)"
          (attachmentImageInserted)="onAttachmentImageInserted($event)">
        </app-rich-editor>
      </div>
    }
  </ng-template>

  <!-- ===================== HISTORY ===================== -->
  <ng-template notePanel="history">
    <div class="w-full px-2 py-2 sm:px-3 sm:py-3 lg:px-4">
      <app-note-empty-state
        icon="history"
        title="Version history will be available here"
        description="Versions, change timestamps, authors, comparison and restore are planned." />
    </div>
  </ng-template>

  <!-- ===================== FOOTER (kept, restyled): actions on the left, save/sync status (icon + text) right-justified ===================== -->
  <div
    noteFooter
    data-note-footer
    class="flex items-center gap-x-3 gap-y-1 border-t border-surface-200 bg-surface-0 px-2 pb-[max(0.25rem,env(safe-area-inset-bottom))] pt-1 dark:border-surface-700 dark:bg-surface-900 print:hidden">
    <div class="flex min-w-0 items-center gap-2">
      @if (!autosaveEnabled) {
        <p-button icon="pi pi-save" label="Save" size="small" class="hidden sm:inline-flex" [disabled]="isSaving" (click)="pageMenu('SaveNote')"></p-button>
        <p-button icon="pi pi-save" label="Save & View" size="small" class="hidden sm:inline-flex" [disabled]="isSaving" (click)="pageMenu('SaveNoteAndView')"></p-button>
        <p-button icon="pi pi-save" label="Save & Close" size="small" [disabled]="isSaving" (click)="pageMenu('SaveNoteAndClose')"></p-button>
        <p-button
          icon="pi pi-times-circle"
          size="small"
          [outlined]="true"
          [label]="isContentChanged ? 'Cancel' : 'Close'"
          (click)="cancelEdits()">
        </p-button>
      } @else {
        <p-button icon="pi pi-eye" label="View" size="small" [outlined]="true" class="hidden sm:inline-flex" [disabled]="isClosing" (click)="pageMenu('View')"></p-button>
        <p-splitButton
          icon="pi pi-times-circle"
          size="small"
          [outlined]="true"
          [model]="closeSplitMenuItems"
          [label]="isClosing ? 'Closing…' : 'Close'"
          [disabled]="isClosing"
          (onClick)="cancelEdits()">
        </p-splitButton>
      }

      <p-button
        icon="pi pi-sparkles"
        label="Find Similar"
        size="small"
        [outlined]="true"
        class="hidden lg:inline-flex"
        [loading]="similarNotesLoading"
        [disabled]="similarNotesLoading || !isReady || !note._id || !isOnline"
        [title]="!isOnline ? 'AI features are only available in online mode' : ''"
        (onClick)="findSimilarNotes()">
      </p-button>

      <button
        #trigger
        type="button"
        class="inline-flex h-9 w-9 cursor-pointer items-center justify-center rounded-full border-0 bg-transparent text-(--p-text-muted-color) hover:bg-(--p-content-hover-background) focus-visible:outline-2 focus-visible:outline-primary"
        aria-label="Editor zoom"
        title="Editor zoom"
        (click)="overlay.toggle($event)">
        <span class="material-symbols-outlined !text-xl" aria-hidden="true">zoom_in</span>
      </button>
      <p-popover #overlay [dismissable]="true" appendTo="body" position="top">
        <div class="flex w-56 flex-col gap-2 p-1">
          <label class="text-sm font-semibold">Editor Zoom</label>
          <p-slider
            [(ngModel)]="editorZoomFactor"
            [min]="50"
            [max]="400"
            [step]="1"
            (onChange)="onZoomFactorChange('editor', editorZoomFactor)"
            (onSlideEnd)="persistEditorZoom()">
          </p-slider>
          <div class="text-center text-sm">{{ editorZoomFactor }}%</div>
        </div>
      </p-popover>
    </div>

    <!-- Save / sync status: the full lifecycle (Unsaved → Saving → Saved locally → Syncing → Saved & synced, or
         Offline / Sync failed / Save failed). Autosave mode shows the state machine; otherwise connectivity + "Unsaved". -->
    <div class="ml-auto flex min-w-0 shrink-0 items-center gap-2 pl-2">
      @if (autosaveEnabled) {
        <span
          class="inline-flex items-center gap-1.5 text-sm"
          role="status"
          aria-live="polite"
          [ngClass]="saveStatusTextClass"
          [attr.aria-label]="autosaveStatusView.label"
          [title]="autosaveStatusView.label">
          <span class="material-symbols-outlined !text-xl" [ngClass]="{ 'animate-spin': autosaveStatusView.spin }" aria-hidden="true">{{ autosaveStatusView.icon }}</span>
          <span class="hidden sm:inline">{{ autosaveStatusView.label }}</span>
        </span>
      } @else {
        <span
          class="inline-flex items-center"
          [attr.aria-label]="connectivity.label"
          [title]="connectivity.label">
          <span class="material-symbols-outlined !text-xl" [ngClass]="connectivity.fullyOnline ? 'text-green-500' : 'text-red-500'">{{ connectivity.icon }}</span>
        </span>
        <span class="hidden items-center gap-1 text-sm sm:inline-flex" [ngClass]="isContentChanged ? 'font-bold text-red-600' : 'text-(--p-text-muted-color)'">
          @if (isContentChanged) { <span class="material-symbols-outlined !text-base" aria-hidden="true">warning</span> }
          {{ statusMessage }}
        </span>
      }
    </div>
  </div>
</app-note-shell>

<!-- ===================== DIALOGS (copied unchanged from the existing Edit; state and handlers are inherited) ===================== -->
    <!-- Unsaved Changes Confirmation Dialog -->
    <p-dialog
      header="Unsaved Changes"
      [(visible)]="unsavedChangesDialogVisible"
      [modal]="true"
      [draggable]="false"
      [resizable]="false"
      [style]="{ width: '420px', maxWidth: '92vw' }"
      [showHeader]="true"
      styleClass="unsaved-changes-dialog"
      appendTo="body"
      [closeOnEscape]="false"
      [closable]="false">
      <div class="flex items-start gap-3">
        <span class="material-symbols-outlined text-4xl text-yellow-500 flex-shrink-0">warning</span>
        <div class="flex flex-col gap-2">
          <p class="text-base font-semibold text-surface-900 dark:text-surface-0 m-0">
            You have unsaved changes
          </p>
          <p class="text-sm text-surface-600 dark:text-surface-300 m-0">
            If you leave without saving, your changes will be lost. Are you sure you want to discard them?
          </p>
        </div>
      </div>
      <ng-template pTemplate="footer">
        <div class="flex gap-2 justify-end">
          <p-button
            label="Keep Editing"
            severity="secondary"
            icon="pi pi-arrow-left"
            (onClick)="onCancelDiscard()"></p-button>
          <p-button
            label="Discard Changes"
            severity="danger"
            icon="pi pi-trash"
            (onClick)="onConfirmDiscard()"></p-button>
        </div>
      </ng-template>
    </p-dialog>

    <!-- Save as Template Dialog -->
    <p-dialog
      header="Save as Template"
      [(visible)]="saveTemplateDialogVisible"
      [modal]="true"
      [draggable]="false"
      [resizable]="false"
      [style]="{ width: '420px', maxWidth: '92vw' }"
      appendTo="body">
      <div class="flex flex-col gap-2">
        <label for="templateName" class="text-sm font-semibold">Template Name</label>
        <input
          id="templateName"
          pInputText
          type="text"
          [(ngModel)]="templateName"
          (blur)="templateNameTouched = true"
          placeholder="Enter a template name"
          class="w-full" />
        <small *ngIf="templateNameTouched && !templateName.trim()" class="text-red-600">
          Template name is required.
        </small>
      </div>
      <ng-template pTemplate="footer">
        <p-button
          label="Cancel"
          severity="secondary"
          icon="pi pi-times"
          (onClick)="saveTemplateDialogVisible = false"></p-button>
        <p-button
          label="Save Template"
          icon="pi pi-save"
          [loading]="isSavingTemplate"
          [disabled]="!templateName.trim()"
          (onClick)="saveTemplateFromDialog()"></p-button>
      </ng-template>
    </p-dialog>

    <!-- tasks/space-move-client.md — Move to Space: pick a destination, confirm. -->
    <p-dialog
      header="Move to Space"
      [(visible)]="moveDialogVisible"
      [modal]="true"
      [draggable]="false"
      [resizable]="false"
      [style]="{ width: '26rem', maxWidth: '94vw' }"
      appendTo="body">
      <div class="flex flex-col gap-3">
        <label for="moveDestinationSpace" class="text-sm font-semibold">Destination Space</label>
        <p-select
          inputId="moveDestinationSpace"
          [options]="moveDestinationOptions"
          optionLabel="label"
          optionValue="id"
          [(ngModel)]="moveDestinationSpaceId"
          [ngModelOptions]="{ standalone: true }"
          placeholder="Choose a Space"
          appendTo="body"
          styleClass="w-full" />
        <p class="m-0 text-xs text-(--p-text-muted-color)">
          The note keeps its content, attachments, private tags and modified date. Its Space tags stay behind in the current Space.
        </p>
      </div>
      <ng-template pTemplate="footer">
        <div class="flex justify-end gap-2">
          <p-button label="Cancel" severity="secondary" [disabled]="isMoving" (onClick)="moveDialogVisible = false"></p-button>
          <p-button
            label="Move"
            icon="pi pi-arrow-right-arrow-left"
            [loading]="isMoving"
            [disabled]="!moveDestinationSpaceId"
            (onClick)="confirmMoveToSpace()"></p-button>
        </div>
      </ng-template>
    </p-dialog>

    <p-dialog
      header="Tag Details"
      [(visible)]="tagDialogVisible"
      [modal]="true"
      [draggable]="false"
      [resizable]="false"
      [style]="{ width: '560px', maxWidth: '94vw' }"
      appendTo="body">
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <div class="flex flex-col gap-1 sm:col-span-2">
          <span class="text-sm font-semibold">Scope</span>
          @if (editingTagScope === null && canCreateSpaceTags) {
            <p-selectbutton
              [options]="tagScopeOptions"
              [(ngModel)]="newTagScope"
              [ngModelOptions]="{ standalone: true }"
              [allowEmpty]="false"
              optionLabel="label"
              optionValue="value"
              size="small"
              ariaLabelledBy="tagDialogScopeLabel" />
            <span id="tagDialogScopeLabel" class="sr-only">Create tag as</span>
          }
          <span class="flex items-center gap-1.5 text-xs text-(--p-text-muted-color)">
            @if ((editingTagScope ?? effectiveNewTagScope) === TAG_SCOPE.PRIVATE) {
              <i class="pi pi-lock !text-[0.7rem]" aria-hidden="true"></i> Private tag — only you can see it.
            } @else {
              <i class="pi pi-users !text-[0.7rem]" aria-hidden="true"></i> Space tag — visible to everyone in this Space.
            }
          </span>
        </div>
        <div class="flex flex-col gap-1 sm:col-span-2">
          <label for="tagName" class="text-sm font-semibold">Name</label>
          <input
            id="tagName"
            pInputText
            type="text"
            [(ngModel)]="tagDraftName"
            [ngModelOptions]="{ standalone: true }"
            (input)="onTagNameDraftChanged()"
            placeholder="Angular"
            class="w-full" />
        </div>

        <div class="flex flex-col gap-1">
          <label for="tagType" class="text-sm font-semibold">Tag Type</label>
          <p-select
            inputId="tagType"
            [options]="tagTypeOptions"
            [(ngModel)]="tagDraftType"
            [ngModelOptions]="{ standalone: true }"
            [editable]="false"
            placeholder="Select tag type"
            class="w-full">
          </p-select>
        </div>

        <div class="flex flex-col gap-1">
          <label for="tagSlug" class="text-sm font-semibold">Slug</label>
          <input
            id="tagSlug"
            pInputText
            type="text"
            [(ngModel)]="tagDraftSlug"
            [ngModelOptions]="{ standalone: true }"
            placeholder="angular"
            class="w-full" />
        </div>

        <div class="flex flex-col gap-1">
          <label for="tagColor" class="text-sm font-semibold">Color</label>
          <input
            id="tagColor"
            pInputText
            type="text"
            [(ngModel)]="tagDraftColor"
            [ngModelOptions]="{ standalone: true }"
            placeholder="#DD0031"
            class="w-full" />
        </div>

        <div class="flex flex-col gap-1">
          <label for="tagIcon" class="text-sm font-semibold">Icon</label>
          <input
            id="tagIcon"
            pInputText
            type="text"
            [(ngModel)]="tagDraftIcon"
            [ngModelOptions]="{ standalone: true }"
            placeholder="angular"
            class="w-full" />
        </div>

        <div class="flex flex-col gap-1 sm:col-span-2">
          <label for="tagParentTagId" class="text-sm font-semibold">Parent Tag</label>
          <div class="flex gap-2 items-center">
            <p-autocomplete
              inputId="tagParentTagId"
              class="flex-1"
              [(ngModel)]="tagDraftParentTag"
              [ngModelOptions]="{ standalone: true }"
              [suggestions]="filteredParentTagSuggestions"
              [dropdown]="true"
              [appendTo]="'body'"
              optionLabel="name"
              placeholder="Optional parent tag"
              (completeMethod)="searchParentTagSuggestions($event)"
              (onSelect)="onParentTagSelected($event)"
              (ngModelChange)="onParentTagInputChanged($event)">
              <ng-template let-tag pTemplate="item">
                <div class="flex items-center gap-2" [ngClass]="{ 'opacity-60': !tag.isActive }">
                    <span class="h-3 w-3 shrink-0 rounded-full border border-black/10" [style.backgroundColor]="tag.color || '#94a3b8'"></span>
                    <div class="min-w-0 flex-1">
                      <div class="truncate text-sm font-medium">{{ tag.name }}</div>
                      <div class="truncate text-xs text-(--p-text-muted-color)">{{ tag.tagType }} · {{ tag.slug }}</div>
                    </div>
                    <span class="shrink-0 text-xs text-(--p-text-muted-color)">{{ getTagStatusLabel(tag) }}</span>
                  </div>
                </ng-template>
            </p-autocomplete>
            <p-button
              icon="pi pi-times"
              severity="secondary"
              text
              [disabled]="!parentTagInputText"
              (onClick)="clearParentTag()">
            </p-button>
          </div>
        </div>

        <div class="flex flex-col gap-1">
          <label for="tagSortOrder" class="text-sm font-semibold">Sort Order</label>
          <input
            id="tagSortOrder"
            pInputText
            type="number"
            [(ngModel)]="tagDraftSortOrder"
            [ngModelOptions]="{ standalone: true }"
            placeholder="10"
            class="w-full" />
        </div>

        <label class="flex items-center gap-2 sm:col-span-2 mt-1">
          <input
            type="checkbox"
            [(ngModel)]="tagDraftIsActive"
            [ngModelOptions]="{ standalone: true }" />
          <span class="text-sm text-surface-700 dark:text-surface-100">Tag is active</span>
        </label>
      </div>

      <ng-template pTemplate="footer">
        <div class="flex gap-2 justify-end">
          <p-button
            *ngIf="editingTagIndex !== null"
            label="Delete"
            severity="danger"
            icon="pi pi-trash"
            [loading]="isTagMutating"
            (onClick)="deleteEditingTag()"></p-button>
          <p-button
            label="Cancel"
            severity="secondary"
            icon="pi pi-times"
            [disabled]="isTagMutating"
            (onClick)="tagDialogVisible = false"></p-button>
          <p-button
            label="Save Tag"
            icon="pi pi-check"
            [loading]="isTagMutating"
            [disabled]="!tagDraftName.trim() || isTagMutating"
            (onClick)="saveTagDialog()"></p-button>
        </div>
      </ng-template>
    </p-dialog>

    <p-dialog
      header="AI Suggested Tags"
      [(visible)]="aiSuggestTagsDialogVisible"
      [modal]="true"
      [draggable]="false"
      [resizable]="false"
      [style]="{ width: '760px', maxWidth: '96vw' }"
      appendTo="body">
      <div class="mb-3 text-sm text-surface-600 dark:text-surface-300">
        Choose which suggested tags should be added to this note.
      </div>

      <p-table
        [value]="aiSuggestedTags"
        styleClass="p-datatable-sm"
        [scrollable]="true"
        [tableStyle]="{ 'min-width': '36rem' }">
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 5rem;">Add</th>
            <th style="width: 12rem;">Name</th>
            <th>Description</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-suggested>
          <tr>
            <td>
              <input
                type="checkbox"
                [(ngModel)]="suggested.selected"
                [ngModelOptions]="{ standalone: true }"
                [attr.aria-label]="'Select tag ' + suggested.name" />
            </td>
            <td class="font-semibold">{{ suggested.name }}</td>
            <td>{{ suggested.description || '—' }}</td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="3" class="text-center py-5 text-surface-500 dark:text-surface-300">
              No fitting tags were suggested for this note.
            </td>
          </tr>
        </ng-template>
      </p-table>

      <ng-template pTemplate="footer">
        <div class="flex gap-2 justify-end">
          <p-button
            label="Cancel"
            severity="secondary"
            icon="pi pi-times"
            (onClick)="cancelSuggestedTagsDialog()"></p-button>
          <p-button
            label="Add selected Tags"
            icon="pi pi-check"
            [disabled]="!hasSelectedSuggestedTags"
            (onClick)="addSelectedSuggestedTags()"></p-button>
        </div>
      </ng-template>
    </p-dialog>

    <!-- Add Related Note Dialog -->
    <p-dialog
      header="Add Related Note"
      [(visible)]="addRelatedNoteDialogVisible"
      [modal]="true"
      [draggable]="false"
      [resizable]="false"
      [style]="{ width: '680px', maxWidth: '96vw' }"
      appendTo="body"
      (onHide)="relatedNoteSearchQuery = ''; relatedNoteSearchResults = []">
      <div class="flex flex-col gap-3 pt-1">
        <input
          pInputText
          type="text"
          class="w-full"
          placeholder="Search notes by title or ID…"
          [(ngModel)]="relatedNoteSearchQuery"
          [ngModelOptions]="{ standalone: true }"
          (ngModelChange)="onRelatedNoteSearch()" />
        <div *ngIf="!relatedNoteSearchQuery.trim()" class="text-sm text-surface-400 dark:text-surface-300 py-2">
          Start typing to search notes.
        </div>
        <p-table
          *ngIf="relatedNoteSearchQuery.trim()"
          [value]="relatedNoteSearchResults"
          styleClass="p-datatable-sm"
          [scrollable]="true"
          scrollHeight="320px">
          <ng-template pTemplate="header">
            <tr>
              <th>Title</th>
              <th class="text-xs" style="width:40%">Note ID</th>
              <th style="width:18%">Modified</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-n>
            <tr class="cursor-pointer hover:bg-surface-100 dark:hover:bg-surface-800" (click)="selectRelatedNote(n)">
              <td class="font-medium">{{ n.Title || '(Untitled)' }}</td>
              <td class="text-xs text-surface-400 truncate max-w-xs" [title]="n._id">{{ n._id }}</td>
              <td class="text-sm text-surface-400 whitespace-nowrap">{{ n.last_modified | date:'dd MMM yyyy' }}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="3" class="text-center py-5 text-surface-400">No matching notes found.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
      <ng-template pTemplate="footer">
        <div class="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-end">
          <label class="inline-flex items-center gap-2 text-sm text-surface-600 dark:text-surface-300 sm:mr-auto">
            <input
              type="checkbox"
              [(ngModel)]="addRelatedNoteCreateBacklink"
              [ngModelOptions]="{ standalone: true }" />
            <span>Add backlink</span>
          </label>
          <p-button
            label="Close"
            severity="secondary"
            icon="pi pi-times"
            (onClick)="addRelatedNoteDialogVisible = false"></p-button>
        </div>
      </ng-template>
    </p-dialog>

    <!-- Find Similar Notes to Link Dialog -->
    <p-dialog
      header="Find Similar Notes to Link"
      [(visible)]="similarForLinkDialogVisible"
      [modal]="true"
      [draggable]="false"
      [resizable]="false"
      [style]="{ width: '70vw', maxWidth: '900px' }"
      [breakpoints]="{ '960px': '90vw', '640px': '95vw' }"
      appendTo="body">
      <ng-template pTemplate="content">
        <div *ngIf="similarForLinkError" class="text-red-600 mb-3 text-sm">{{ similarForLinkError }}</div>
        <p-table
          [value]="similarForLinkResults"
          [loading]="similarForLinkLoading"
          styleClass="p-datatable-sm"
          [paginator]="similarForLinkResults.length > 15"
          [rows]="15">
          <ng-template pTemplate="header">
            <tr>
              <th style="width:4rem">Link</th>
              <th style="width:30%">Title</th>
              <th style="width:18%">Status</th>
              <th style="width:18%">Modified</th>
              <th style="width:10%">Score</th>
              <th style="width:4rem"></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item>
            <tr [ngStyle]="relatedNoteRowStyle(item.Status || '')">
              <td>
                <input
                  type="checkbox"
                  [(ngModel)]="item.selected"
                  [ngModelOptions]="{ standalone: true }" />
              </td>
              <td [ngStyle]="relatedNoteRowStyle(item.Status || '')">{{ item.title || '—' }}</td>
              <td class="text-sm" [ngStyle]="relatedNoteRowStyle(item.Status || '')">{{ item.Status || '—' }}</td>
              <td class="text-sm whitespace-nowrap" [ngStyle]="relatedNoteRowStyle(item.Status || '')">{{ formatSimilarForLinkDate(item) }}</td>
              <td class="text-sm" [ngStyle]="relatedNoteRowStyle(item.Status || '')">
                {{ item.final_score != null ? (item.final_score | number:'1.2-2') : '' }}
              </td>
              <td class="text-center">
                <a pButton
                  icon="pi pi-eye"
                  [rounded]="true"
                  [text]="true"
                  size="small"
                  [routerLink]="['/view', getSimilarForLinkNoteId(item)]"
                  target="_blank"
                  rel="noopener"
                  pTooltip="View note"
                  tooltipPosition="left"></a>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="6" class="text-center text-surface-400 py-6">
                <span *ngIf="!similarForLinkLoading">No similar notes found.</span>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </ng-template>
      <ng-template pTemplate="footer">
        <div class="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-end">
          <label class="inline-flex items-center gap-2 text-sm text-surface-600 dark:text-surface-300 sm:mr-auto">
            <input
              type="checkbox"
              [(ngModel)]="createBacklinksChecked"
              [ngModelOptions]="{ standalone: true }" />
            <span>Create Backlinks</span>
          </label>
          <p-button
            label="Cancel"
            severity="secondary"
            icon="pi pi-times"
            (onClick)="similarForLinkDialogVisible = false"></p-button>
          <p-button
            label="Link Selected"
            icon="pi pi-link"
            [disabled]="!hasSelectedSimilarForLink || similarForLinkLoading"
            (onClick)="linkSelectedSimilarNotes()"></p-button>
        </div>
      </ng-template>
    </p-dialog>

<!-- Remove Related Note Confirmation Dialog -->
<p-dialog
  header="Remove Related Note"
  [(visible)]="removeRelatedNoteDialogVisible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '380px' }"
  [breakpoints]="{ '640px': '95vw' }"
  appendTo="body">
  <p class="text-sm mb-4">
    Remove <strong>{{ removeRelatedNotePendingTitle }}</strong> from Related Notes?
  </p>
  <div class="flex items-center gap-2">
    <input
      type="checkbox"
      id="removeRelatedDeleteBacklink"
      [(ngModel)]="removeRelatedNoteDeleteBacklink"
      [ngModelOptions]="{ standalone: true }"
      [disabled]="!removeRelatedNoteHasBacklink"
      class="cursor-pointer" />
    <label
      for="removeRelatedDeleteBacklink"
      [ngClass]="{ 'opacity-40 cursor-not-allowed': !removeRelatedNoteHasBacklink, 'cursor-pointer': removeRelatedNoteHasBacklink }"
      class="text-sm select-none">
      Delete backlink
      <span *ngIf="!removeRelatedNoteHasBacklink" class="text-surface-400 ml-1">(no backlink exists)</span>
    </label>
  </div>
  <ng-template pTemplate="footer">
    <p-button
      label="Cancel"
      severity="secondary"
      (onClick)="removeRelatedNoteDialogVisible = false">
    </p-button>
    <p-button
      label="Remove"
      severity="danger"
      (onClick)="confirmRemoveRelatedNote()">
    </p-button>
  </ng-template>
</p-dialog>

<!-- Similar Notes Dialog -->
<p-dialog
  header="Similar Notes"
  [(visible)]="similarNotesDialogVisible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '70vw', maxWidth: '900px' }"
  [breakpoints]="{ '960px': '90vw', '640px': '95vw' }">
  <ng-template pTemplate="content">
    <div *ngIf="similarNotesError" class="text-red-600 mb-3 text-sm">{{ similarNotesError }}</div>
    <p-table
      [value]="similarNotesResults"
      [loading]="similarNotesLoading"
      styleClass="p-datatable-sm"
      [paginator]="similarNotesResults.length > 15"
      [rows]="15">
      <ng-template pTemplate="header">
        <tr>
          <th style="width:30%">ID</th>
          <th style="width:45%">Title</th>
          <th style="width:25%">Modified</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr class="hover:bg-blue-50 dark:hover:bg-blue-900/30">
          <td class="text-xs text-gray-500 truncate max-w-xs" title="{{ getSimilarNoteId(item) }}">{{ getSimilarNoteId(item) }}</td>
          <td class="font-medium">
            <a [routerLink]="['/view', getSimilarNoteId(item)]" target="_blank" rel="noopener" class="hover:underline cursor-pointer">{{ item.title || '-' }}</a>
          </td>
          <td class="text-sm text-gray-500 whitespace-nowrap">{{ formatSimilarNoteDate(item) }}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="3" class="text-center text-gray-500 py-6">
            <span *ngIf="!similarNotesLoading">No similar notes found.</span>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </ng-template>
</p-dialog>

